// extracted by mini-css-extract-plugin
export default {"front":"PopupContainer_front__Kb8UY","Background":"PopupContainer_Background__o3Gbe"};